import axios from "../plugins/axios.plugin";

class PushNotificationService {
  baseServicePath = "/api/push-notification-token";
  notificationServicePath = "/api/push-notification";

  createPushNotification(payLoad) {
    return axios.post(`${this.baseServicePath}/store`, payLoad);
  }

  sendPushNotification(payLoad) {
    return axios.post(`${this.notificationServicePath}/firebase/send`, payLoad);
  }
}

export const pushNotificationService = new PushNotificationService();
